import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { Btn, H4 } from "../../AbstractElements";
import { ActualFileUpload, DropFilesHereOrClickToUpload, DropFileUploadText, SearchTableButton } from "../../utils/Constant";
import { URL_API } from "../../utils/helper/helpers"
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import SweetAlert from 'sweetalert2';
import { useEffect, useState } from "react";
import useUsersListe, { changeStatus, deleteUsers } from "./UserApi";
import useRolesList from "../Roles/RoleApi";
import { H6 } from '../../AbstractElements'
import { toast } from "react-toastify";
import axios from "axios";
import { Dropzone, ExtFile, FileMosaic } from "@dropzone-ui/react";
import { formatPhoneNumber, itemHasPermission } from "../../utils/helper/helpers";
// import { ExtFile, FileMosaic } from "@dropzone-ui/react";

type Users = { [key: string]: any }

const GestUsers = () => {

    const [filterText, setFilterText] = useState("");
    const [filteredItems, setFilteredItems] = useState<Users[]>([]);
    const [refresh, setRefresh] = useState(false); // État de rafraîchissement
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const users = useUsersListe(refresh) || [];
    const roles = useRolesList(refresh) || [];
    const [data, setData] = useState({
        name: '',
        firstname: '',
        email: '',
        phone: '',
        role: [] as number[],
        role_libelle: [] as string[],
        signature: null as File | null,
        file: [] as ExtFile[],
        id: null
    });
    const [erreur, setErreur] = useState({
        name: '',
        firstname: '',
        email: '',
        phone: '',
        role: [] as number[],
        role_libelle: [] as string[],
        signature: [] as ExtFile[],
        id: null
    });

    const authUser = JSON.parse(localStorage.getItem("user")!)
    const Token = JSON.parse(localStorage.getItem("login")!);

    // Gestion du filtrage des utilisateurs
    useEffect(() => {
        const filtered = users.filter((item) =>
            (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
            (item.firstname && item.firstname.toLowerCase().includes(filterText.toLowerCase()))
        );
        setFilteredItems(filtered);
    }, [users, filterText]);

    const updateFiles = (incomingFiles: ExtFile[]) => {
        setData((prevState) => ({
            ...prevState,
            file: incomingFiles,
            signature: incomingFiles[0]?.file || null,
        }));
    };
    const removeFile = (id: string | number | undefined) => {
        setData((prevState) => ({
            ...prevState,
            file: data.file.filter((x: ExtFile) => x.id !== id),
            signature: null
        }));
    };

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, type, value } = e.target;

        if (type === 'checkbox' && e.target instanceof HTMLInputElement) {
            const checked = e.target.checked; // On accède à 'checked' uniquement si c'est un 'input' de type 'checkbox'
            const roleId = parseInt(value);
            setData(prev => ({
                ...prev,
                role: checked ? [...prev.role, roleId] : prev.role.filter(id => id !== roleId)
            }));
        } else {
            setData({ ...data, [name]: value });
        }

    };

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        // Validation et soumission des données
        const url = data.id !== null ? `${URL_API}/user/update` : `${URL_API}/user/create`

        axios.post(url, { ...data }, {
            headers: {
                Authorization: `Bearer ${Token}`,
                'Content-Type': 'multipart/form-data',
            }
        }).then(response => {

            if (response.data.success) {
                const msg = data.id !== null ? "Utilisateur modifié avec succès !!" : "Utilisateur ajouté avec succès !!";
                toast.success(msg);
                clearDataForm();
            }

        }).catch(error => {
            // console.error(error.data);
            toast.info(error.response.data.message);
            if (error.status == 405) {
                setErreur(error.response.data.message);
            }
        })
        setRefresh((prev) => !prev);
        setIsSubmitting(false);

    };

    const Confirmation = ({ id, type }: { id: number, type: string }) => {
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: type === 'supprimer' ? "Voulez-vous vraiment supprimer cet utilisateur ?" : "Voulez-vous changer le statut de cet utilisateur ?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: type === 'supprimer' ? 'Oui, Supprimer !' : 'Oui, Changer'
        }).then((result) => {
            if (result.isConfirmed) {
                type == 'supprimer' ? deleteUsers({ id: id }, () => setRefresh(!refresh)) : changeStatus({ id: id }, () => setRefresh(!refresh));
            }
        });
    };

    const clearDataForm = () => {
        setData({
            name: '',
            firstname: '',
            email: '',
            role: [],
            role_libelle: [],
            signature: null as File | null,
            file: [] as ExtFile[],
            phone: '',
            id: null
        });
        setErreur({
            name: '',
            firstname: '',
            email: '',
            role: [],
            role_libelle: [],
            signature: [] as ExtFile[],
            phone: '',
            id: null
        });
    };

    const editeData = ({ id }: { id: number }) => {

        const user = users.find((item) => item.id === id);

        if (user) {
            setData({
                email: user.email,
                firstname: user.firstname,
                name: user.name,
                phone: user.phone,
                role: user.role_id ? user.role_id.split(',').map((id: string) => parseInt(id.trim(), 10)) : [],
                role_libelle: user.role_libelle ? user.role_libelle.split(',') : [],
                signature: null as File | null, // avoir
                file: [] as ExtFile[], // avoir
                id: user.id ?? null,
            });
        } else {
            toast.info('Cet element de figure pas dans nos données')
        }

    }

    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Utilisateur" parent="Gest.Utilisateur" />
            <Container fluid>
                <Row>
                    <Col lg="8">
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm="6">
                                        <div className="dataTables_filter d-flex align-items-center">
                                            <Label className="me-2">{SearchTableButton}:</Label>
                                            <Input
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                type="search"
                                                value={filterText}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                            <Table responsive id="all-invoice" striped={true}>
                                <thead className="bg-info">
                                    <tr>
                                        <th scope="col" className="text-white">Id</th>
                                        <th scope="col" className="text-white">Nom & Prénom</th>
                                        <th scope="col" className="text-white">Téléphone</th>
                                        <th scope="col" className="text-white text-center">Rôles</th>
                                        {
                                            (itemHasPermission('super admin') || itemHasPermission('gest. utilisateur ecriture') || itemHasPermission('admin')) && (
                                                <th scope="col" className="text-white">Actions</th>
                                            )
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        filteredItems.map((item, index) => {
                                            if (item.name === "Super") {
                                                return null; // Ne rien rendre pour cet élément
                                            }
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        <span className="fw-bold ">
                                                            #{index + 1}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className="fw-bold ">
                                                            {item.name + " " + item.firstname}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className="fw-bold ">
                                                            {formatPhoneNumber(item.phone)}
                                                        </span>
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        {
                                                            item.role_libelle && typeof item.role_libelle === 'string'
                                                                ? item.role_libelle.split(',').map((roleItem, i) => (
                                                                    <>
                                                                        <span className=" fw-bold text-capitalize" key={i}> {roleItem}</span><span className="mx-1">|</span> <br />
                                                                    </>
                                                                )) : null
                                                        }
                                                    </td>


                                                    {
                                                        item.id === authUser.id ? (
                                                            <td></td>
                                                        ) : (
                                                            (itemHasPermission('super admin') || itemHasPermission('gest. utilisateur ecriture') || itemHasPermission('admin')) && (
                                                                <td>
                                                                    {item.status === 'actif' ? (
                                                                        <Button className="btn btn-xs btn-success" onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                                            Actif
                                                                        </Button>
                                                                    ) : (
                                                                        <Button className="btn btn-xs btn-warning" onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                                            Inactif
                                                                        </Button>
                                                                    )}
                                                                    <Btn className='bg-info btn-xs mx-1 my-1' onClick={() => editeData({ id: item.id })}>
                                                                        <i className='fa fa-pencil'></i>
                                                                    </Btn>
                                                                    <Btn className='bg-danger btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id, type: 'supprimer' })}>
                                                                        <i className='fa fa-trash'></i>
                                                                    </Btn>
                                                                </td>
                                                            )
                                                        )

                                                    }
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </Table>
                        </Card>
                    </Col>
                    <Col lg="4">
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmitData}>
                                    <H4 className="my-4">
                                        {
                                            data.id == null ? ("Ajouter un nouveau utilisateur") : ("Modification d'un utilisateur")
                                        }
                                    </H4>

                                    <div className="product-info">
                                        <div className="product-group">
                                            <Row>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>Nom</Label>
                                                        <Input
                                                            placeholder="Entrer le nom"
                                                            name="name"
                                                            value={data.name}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.name && (
                                                            <span className="text-danger">{erreur.name}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>Prénoms</Label>
                                                        <Input
                                                            placeholder="Entrer le prénom"
                                                            name="firstname"
                                                            value={data.firstname}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.firstname && (
                                                            <span className="text-danger">{erreur.firstname}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>E-mail</Label>
                                                        <Input
                                                            placeholder="Entrer l'e-mail"
                                                            name="email"
                                                            value={data.email}
                                                            onChange={changeHandler}
                                                            type="email"
                                                        />
                                                        {erreur.email && (
                                                            <span className="text-danger">{erreur.email}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>Téléphone</Label>

                                                        <Input
                                                            placeholder="Entrer le numéro téléphone"
                                                            name="phone"
                                                            value={data.phone}
                                                            onChange={changeHandler}
                                                            type="number"
                                                        />
                                                        {erreur.phone && (
                                                            <span className="text-danger">{erreur.phone}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="12">
                                                    <div className="card-wrapper solid-border rounded-3">
                                                        <H6 className="sub-title f-w-500">Rôles utilisateur</H6>
                                                        {roles.map((item, i) => (
                                                            item.status === 'actif' && item.libelle !== 'super admin' ? (
                                                                // item.status === 'actif' && item.libelle != "admin" ? (
                                                                <>

                                                                    <Label className="mx-1 text-capitalize" for={`checkbox-primary${i}`} check key={i}>
                                                                        <Input
                                                                            className={`checkbox-primary checkbox-border-primary`}
                                                                            onChange={changeHandler}
                                                                            name="role"
                                                                            value={item.id}
                                                                            id={`checkbox-primary${i}`}
                                                                            type="checkbox"
                                                                            checked={Array.isArray(data.role) && data.role.includes(item.id)} // Correction ici
                                                                        />
                                                                        {item.libelle}
                                                                    </Label>
                                                                </>
                                                            ) : null
                                                        ))}
                                                        {erreur.role && (
                                                            <span className="text-danger">{erreur.role}</span>
                                                        )}
                                                    </div>
                                                </Col>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label check>Importer la signature</Label>
                                                        <Dropzone onChange={updateFiles} value={data.file} maxFiles={1} header={false} footer={false} minHeight="80px" label="Drag'n drop files here or click to Browse">
                                                            {data.file.map((file: ExtFile) => (
                                                                <FileMosaic key={file.id} {...file} onDelete={removeFile} info={true} />
                                                            ))}
                                                            {data.file.length === 0 && (
                                                                <div className="dz-message needsclick p-5">
                                                                    <i className="icon-cloud-up font-primary"></i>
                                                                    <H6>{DropFilesHereOrClickToUpload}</H6>
                                                                    <span className="note needsclick">
                                                                        {DropFileUploadText}<strong>not</strong>{ActualFileUpload}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </Dropzone>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <div className="text-end mt-3">
                                        {
                                            (itemHasPermission('admin') || itemHasPermission('super admin') || itemHasPermission('gest. utilisateur ecriture')) && (
                                                <>
                                                    <Btn color="info" type="submit">
                                                        {data.id == null ? "Ajouter" : "Sauvegarder"}
                                                    </Btn>
                                                    <Btn className="btn btn-danger ms-3" onClick={() => clearDataForm()}>
                                                        Annuler
                                                    </Btn>
                                                </>
                                            )
                                        }

                                    </div>
                                </Form>
                            </CardBody>

                        </Card>

                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default GestUsers